import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function getAllParcours() {
    try {
      const response = await fetch(base + 'parcours-inde');
      return await response.json();
    } catch (error) {
      console.error('Erreur getAllParcours', error);
      throw error;
    }
}
  
export async function getAllParcoursByGame(g) {
    try {
        const response = await fetch(base + 'parcours-inde/g/' + g);
        return await response.json();
    } catch (error) {
        console.error('Erreur getAllParcoursByGame', error);
        throw error;
    }
}

export async function getParcours(p) {
    try {
        const response = await fetch(base + 'parcours-inde/' + p);
        return await response.json();
    } catch (error) {
        console.error('Erreur getParcours', error);
        throw error;
    }
}
    
export async function createParcours(gameId, parcoursName) {
    try {
        const response = await fetch(base + 'parcours-inde/insert', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ nom: parcoursName, id_game: gameId }),
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur createParcours', error);
        throw error;
    }
}
    